import { Deserializable } from '../protocols/deserializable';

export class MemberApprovedSubmission implements Deserializable {
  public id!: number;
  public prefix!: string;
  public suffix!: string;

  // Not from API

  public formattedSubmissionId!: string;

  public onDeserialize(): void {
    this.formattedSubmissionId = `${this.prefix}-${this.id.toString().padWithLeadingZeros(8)}-${this.suffix}`;
  }
}
